// Urlaub/Krank für den Kalender (nur lesen): ein Eintrag erscheint nur, wenn Mitarbeiter und Benutzer eindeutig zusammenpassen.
// Eine Stelle für Terminseite und Planung (Kopfleiste).
import { api } from "@/lib/api";
import { mitarbeiterZuBenutzer } from "./kalenderLogik";

export const ladeAbwesenheiten = async (benutzer) => {
  try {
    const [ma, abw] = await Promise.all([api.get("/mitarbeiter"), api.get("/mitarbeiter-abwesenheiten")]);
    const zu = mitarbeiterZuBenutzer(ma.data || [], benutzer);
    return (abw.data || [])
      .filter((a) => zu.has(a.mitarbeiter_id) && a.status !== "abgelehnt")
      .map((a) => ({ username: zu.get(a.mitarbeiter_id), name: a.name, von: a.von, bis: a.bis, typ: a.typ === "krank" ? "krank" : "urlaub" }));
  } catch { return []; }
};
